import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import Divider from 'dashboard/components/Divider';
import FileUpload from 'dashboard/components-lib/FileUpload';
import { DragContainer } from 'dashboard/components-lib/FileUpload/FileUpload';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import Banner from 'design-system/components/Banner';
import Button from 'design-system/components/Button';
import { HStack } from 'design-system/components/Stack';
import { Paragraph, Span } from 'design-system/components/Text';

const StyledModalContainer = styled(ModalContainer)`
  padding-top: ${Spacing[0]};
`;

const StyledModalHeader = styled(ModalHeader)`
  padding: ${Spacing[3]} ${Spacing[4]};
`;

const StyledModalBody = styled(ModalBody)`
  padding: ${Spacing[5]};
`;

const FooterDivider = styled(Divider)`
  margin: ${Spacing[4]} -${Spacing[5]};
`;

const StyledDivider = styled(Divider)`
  margin: ${Spacing[0]};
`;

const DividerWithOrContainer = styled('div')`
  display: flex;
  align-items: center;
  width: 100%;

  ${Divider}:first-child {
    margin-right: 8px;
    width: 100%;
  }

  ${Divider}:last-child {
    margin-left: 8px;
    width: 100%;
  }

  ${Span} {
    white-space: nowrap;
  }
`;

const StyledFileUpload = styled(FileUpload)`
  display: flex;
  height: 78px;
  padding: ${Spacing[4]};
  align-items: center;
  align-self: stretch;

  ${DragContainer} {
    flex-direction: row;
    justify-content: space-between;
    padding: ${Spacing[0]};
  }
`;

const RightAlignedButtonGroup = styled(HStack).attrs({ justify: 'flex-end' })``;

const StyledBanner = styled(Banner)`
  display: flex;
  height: 45px;
  padding: ${Spacing[2]};
  align-items: center;
  align-self: stretch;
`;

const ResultsRow = styled('div')`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  justify-content: space-between;

  ${Paragraph} {
    flex: 0 0 50%;
  }
`;

const ResultsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  ${Divider} {
    margin: 0;
    width: 100%;
  }

  ${ResultsRow}:last-child {
    padding-top: ${Spacing[2]};
  }
`;

const StyledList = styled('ul')`
  padding: 0 ${Spacing[4]};
`;

const ClearButton = styled(Button)`
  position: absolute;
  top: ${Spacing[2]};
  right: ${Spacing[2]};
`;

export {
  ClearButton,
  StyledList,
  StyledModalContainer,
  StyledModalHeader,
  StyledModalBody,
  FooterDivider,
  StyledDivider,
  DividerWithOrContainer,
  StyledFileUpload,
  RightAlignedButtonGroup,
  StyledBanner,
  ResultsContainer,
  ResultsRow,
};
